import React from 'react';
import { LeashContent } from 'leash/utilities/localStorage/leashContentStorage';
import { ChaperoneCompany } from 'types';
import Select from 'antd/lib/select';
import Form from 'antd/lib/form';

const { Option } = Select;

interface Props {
  label?: string;
  placeholder?: string;
  name?: string;
  required?: boolean;
  onChange?: (e: number) => void;
}

export function FieldChaperone(props: Props) {
  if (!LeashContent?.puppyChaperoneCompanies) return null;
  const {
    label = 'Chaperone',
    placeholder = 'Select a chaperone',
    name = 'puppyChaperoneCompanyId',
    required = false,
    onChange = () => 0,
  } = props;

  return (
    <Form.Item
      name={name}
      label={label}
      rules={[{ required, message: 'Please select one option' }]}
    >
      <Select
        data-testid="chaperone"
        placeholder={placeholder}
        onChange={onChange}
        allowClear
      >
        {LeashContent.puppyChaperoneCompanies.map(
          (c: ChaperoneCompany) =>
            c.isActive && (
              <Option value={c.id} key={c.id}>
                {c.name}
              </Option>
            ),
        )}{' '}
      </Select>
    </Form.Item>
  );
}
